import noUiSlider from "./nouislider.min.mjs";

class PriceSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = null;
    this.inputFrom = null;
    this.inputTo = null;
    this.facetForm = null;
    this.initialized = false;
  }

  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;

    this.init();
  }

  init() {
    const priceSlider = this.querySelector(".f-price__slider");
    const inputFrom = this.querySelector(".f-price__input--from");
    const inputTo = this.querySelector(".f-price__input--to");

    if (!priceSlider || !inputFrom || !inputTo) {
      this.initialized = false;
      return;
    }

    this.slider = priceSlider;
    this.inputFrom = inputFrom;
    this.inputTo = inputTo;

    this.facetForm = this.closest("facet-filters-form")?.querySelector("form");

    const rangeMin = Number(priceSlider.dataset.min || 0);
    const rangeMax = Number(priceSlider.dataset.max || 0);
    const step = Number(priceSlider.dataset.step || 1);

    const isRtl =
      document.documentElement.getAttribute("dir") === "rtl";

    // Prevent duplicate initialization
    if (priceSlider.noUiSlider) {
      priceSlider.noUiSlider.destroy();
    }

    noUiSlider.create(priceSlider, {
      start: [
        Number(inputFrom.value || rangeMin),
        Number(inputTo.value || rangeMax),
      ],
      connect: true,
      step,
      tooltips: [true, true],
      range: {
        min: rangeMin,
        max: rangeMax,
      },
      direction: isRtl ? "rtl" : "ltr",
      format: wNumb({
        decimals: 0,
        thousand: "",
        prefix: "",
      }),
    });

    // Make slider handles inaccessible when inside collapsible filter
    const collapsible = this.closest(".f-price-slider");

    if (collapsible) {
      const uiHandlers =
        priceSlider.querySelectorAll(".noUi-handle");

      this.setTabindex(uiHandlers, "-1");
    }

    const debouncedUpdate = this.debounce(
      (values, handle) => {
        const value = values[handle];

        if (handle === 0) {
          this.inputFrom.value = value;
          this.inputFrom.setAttribute("value", value);
        } else {
          this.inputTo.value = value;
          this.inputTo.setAttribute("value", value);
        }

        if (this.facetForm) {
          this.facetForm.dispatchEvent(
            new Event("input", {
              bubbles: true,
            })
          );
        }
      },
      300
    );

    priceSlider.noUiSlider.on("change", (values, handle) => {
      debouncedUpdate(values, handle);
    });

    this.inputFrom.addEventListener("change", () => {
      priceSlider.noUiSlider.set([
        this.inputFrom.value,
        null,
      ]);
    });

    this.inputTo.addEventListener("change", () => {
      priceSlider.noUiSlider.set([
        null,
        this.inputTo.value,
      ]);
    });
  }

  setTabindex(elements, value) {
    elements.forEach((element) => {
      element.setAttribute("tabindex", value);
    });
  }

  debounce(func, wait) {
    let timeout;

    return (...args) => {
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        func.apply(this, args);
      }, wait);
    };
  }

  disconnectedCallback() {
    if (this.slider?.noUiSlider) {
      this.slider.noUiSlider.destroy();
    }

    this.slider = null;
    this.inputFrom = null;
    this.inputTo = null;
    this.facetForm = null;
    this.initialized = false;
  }
}

if (!customElements.get("price-slider")) {
  customElements.define("price-slider", PriceSlider);
}